module.exports = window.__loadMfRemote("postSaleBaggage", "postSaleBaggageUrl");